// extracted by mini-css-extract-plugin
module.exports = {"iframe":"Main_iframe__3FItb","root":"Main_root__1fzJ5","panel":"Main_panel__gXvgn","h2":"Main_h2__1fuju"};